import React, { useState } from 'react';
const Context = React.createContext(null)

const ContextProvider = (props) => {
    const [problems, setProblems] = useState(null)
    const [currentProblemState, setCurrentProblemState] = useState({})
    const [isLogedIn, setIsLogedIn] = useState(false)
    const [myToken, setMyToken] = useState(null)
    const [leaderboardData, setLeaderBoardData] = useState(null)
    const [profileData, setProfileData] = useState(null)
    return (
        <Context.Provider value={{
            problems, setProblems,
            currentProblemState, setCurrentProblemState,
            isLogedIn, setIsLogedIn,
            myToken, setMyToken,
            leaderboardData, setLeaderBoardData,
            profileData, setProfileData
        }}>
            {props.children}
        </Context.Provider>
    )
}

export { Context, ContextProvider }